import {
  decryptPermissions,
  decryptToken,
  decryptUserEmail,
  decryptUserName,
  encryptToken,
  encryptUserEmail,
  encryptUserName,
  encryptedPermissions,
} from "./encryptUser";

export const setAuthToken = (token: string) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("token", encryptToken(token));
  }
};

export const getAuthToken = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const token = sessionStorage.getItem("token");
    return token ? decryptToken(token) : "";
  }
  return "";
};

export const setUserId = (id: number) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("id", id.toString());
  }
};

export const getUserId = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const id = sessionStorage.getItem("id");
    return id ? parseInt(id) : 0;
  }
  return 0;
};

export const removeAuthToken = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.removeItem("token");
  }
};

export const setUserName = (userName: string) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("userName", encryptUserName(userName));
  }
};

export const getUserName = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const userName = sessionStorage.getItem("userName");
    return userName ? decryptUserName(userName) : "Admin";
  }
  return "Admin";
};

export const setUserEmail = (userEmail: string) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("userEmail", encryptUserEmail(userEmail));
  }
};

export const getUserEmail = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const userEmail = sessionStorage.getItem("userEmail");
    return userEmail ? decryptUserEmail(userEmail) : "";
  }
  return "";
};

export const removeUserName = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.removeItem("userName");
  }
};

export const setPermissions = (permissions: string[]) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("permissions", encryptedPermissions(permissions));
  }
};

export const getPermissions = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const permissions = sessionStorage.getItem("permissions");
    return permissions ? decryptPermissions(permissions) : [];
  }
  return [];
};

export const removePermissions = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.removeItem("permissions");
  }
};

export const setUserCountryId = (countryId: string) => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.setItem("countryId", countryId);
  }
};

export const removeUserCountryId = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    sessionStorage.removeItem("countryId");
  }
};

export const getUserCountryId = () => {
  if (
    typeof navigator !== "undefined" &&
    typeof window !== "undefined"
  ) {
    const id = sessionStorage.getItem("countryId");
    return id ? parseInt(id) : 0;
  }
  return 0;
};
